module.exports = __webpack_public_path__ + "img/setting.bf1a12f7.png";